module.exports = __webpack_public_path__ + "img/15_88.7b19be54.png";